import React from 'react';
import '../scss/linecardtile.scss';

function LineCardTile(props) {

  return (
    <div class="col-12 col-md-6 col-xl-4 bottom-border">
      <div class="linecardtile-container">
        <img className="linecard-image" src={require(`./images/linecardLogos/${props.image}`)} alt={props.name} />
        <div className="linecard-description" dangerouslySetInnerHTML={{ __html: props.description }}/>
        <a href={props.infoLink}>
          <button className="button">{props.name}</button>
        </a>
      </div>
    </div>
  );
}

export default LineCardTile;
